const release = '0.14.2'

module.exports = { release }



// WEBPACK FOOTER //
// ./release.js